import React, { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import UserCard from "./userCard";

export default function Associado(params) {
  const { idDoUserParam } = useParams();
  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
  const url = useMemo(() => `${baseUrl}/content/associado/${idDoUserParam}`, [baseUrl, idDoUserParam]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [user, setUser] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {

    const fetchData = () => {
      setLoading(true);
      fetch(url, {
        method: 'GET',
        headers: requestHeaders
        })
        .then((response) => response.json())
        .then((result) => {
          setUser(result);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
    fetchData();
  }, [url, requestHeaders]);

    if (isLoading) {
      return <CircularProgress className="loading" />;
    }
    return (
      <div>
        <Box className="associado maincontent">
          <UserCard user={user} name={idDoUserParam} location="associado"/>
        </Box>
      </div>
    );
  }